const REPLY_SORTING_OPTIONS: { [key: string]: string } = {
  oldestFirst: 'Oldest first',
  mostRecentFirst: 'Newest first',
  mostLiked: 'Most liked'
}

function setRepliesPaginationParams(query: { page?: number, pageSize?: number }) {
  const searchParams = new URLSearchParams(window.location.search)
  const { page, pageSize } = query
  if (page) {
    searchParams.set('page', String(page))
  }
  if (pageSize) {
    searchParams.set('size', String(pageSize))
  }
  const newURL = window.location.pathname + '?' + searchParams.toString() + window.location.hash
  history.replaceState(null, '', newURL)
}

export {
  REPLY_SORTING_OPTIONS,
  setRepliesPaginationParams
}
